// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"142":"b0028cc14c1d0865","619":"9e74c6a1d872b9b1"}[chunkId] + ".js";
};